export function safeHref(href?: string) {
	if (!href) return ""

	return href === "https://#" ? "#" : href
}
